import { Component, OnInit, Input, Inject, ViewChild, AfterViewInit, ElementRef, Output, EventEmitter, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
// import { UsersState } from 'app/app.reducer';
import { ConfirmDialogService, ConfirmDialogState } from 'app/components/dialogs/confirm-dialog/confirm-dialog.service';
import { getFileExtensions } from 'app/shared/util';
import { StorageService } from 'app/storageprovider';
import { ContenteditableComponent } from 'app/_modules/contenteditable/contenteditable.component';
import { DnDialogService } from 'app/_modules/dn-dialog/dn-dialog.service';
import { PictureViewerService } from 'app/_modules/picture-viewer/picture-viewer.service';
import { SocketFacade } from 'app/_modules/socket/socket.facade';
import { BlacklistService } from 'app/_service/blacklist/blacklist.service';
import { NotificationService } from 'app/_service/notification/notification.service';
import { Utility } from 'app/_service/utility';
import { combineLatest, Subject, Unsubscribable } from 'rxjs';
import { delay, filter, first, map, take, takeUntil, tap } from 'rxjs/operators';
import { UserService } from '../../../_service/user/user.service';
import { HttpClientHelper } from 'app/_service/http-helper';
import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { ToastService } from 'app/_service/toast/toast.service';
import { RechargeBoxService } from 'app/_service/recharge-box/recharge-box.service';

@Component({
  selector: 'app-chat-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {


  private subscriptions: Array<Unsubscribable> = [];

  @Input()
  showSidebar = false;

  @Input()
  partner;

  @Input()
  fromSticky = false;

  @Output()
  onCloseChatLog = new EventEmitter();

  showEmojiBox = false;

  userInput: string;
  selectedUser;
  loadingMessages$;
  loadingContacts$;
  selectCurrentMessagesGroupByDateTime$;
  isUserBlocked$;
  latestMessage$;
  contacts$;
  settings$;
  contacts;
  noHistory$;
  selectedContact$;
  user: any;
  loading: boolean = false;
  setAttensionLoading: boolean = false;
  allLoaded = false;
  initiallized = false;
  showYouChatSettings = false;
  unreadMessages: any[] = [];
  showChatMenu = false;
  mode: "BROWSE" | "LISTEN" = "LISTEN";
  isDark = false;
  private unsubscribe$ = new Subject<void>();
  @ViewChild('youChatLog') youChatLog: ElementRef;
  @ViewChild(ContenteditableComponent) editor: ContenteditableComponent;
  @ViewChild("imageInput") imageInput: ElementRef;

  reportReasons = [
    { name: '政治', id: 0 },
    { name: '色情', id: 1 },
    { name: '恶意骚扰', id: 2 },
    { name: '发布广告', id: 3 },
    { name: '其它', id: 4 },
  ]

  allowImageExtensions =
    [
      ".jpeg",
      ".jpg",
      ".gif",
      ".png"
    ]
  reportReason = this.reportReasons[0].id;
  maxiumImageFileSize: number = 10 * 1024 * 1024;
  openList;
  @ViewChild("emojiPickerElem") emojiPickerElem;
  @ViewChild("chatMenuElem") chatMenuElem;
  reportForm: FormGroup;
  contactsNums = 0;
  privateUserLoaded = true;

  messageSound = './assets/sound/message.mp3';
  audio: any;
  unreadMessage$;
  unreadSocketMsgs = 0;
  lastSocketUnread = 0;
  isFirstOpen = true;
  //forbidInitialScrollMsg = true;
  constructor(
    public socketFacade: SocketFacade,
    // @Inject(AppStore) private store: Store<UsersState>,
    private _storage: StorageService,
    private _confirmDialogService: ConfirmDialogService,
    private _dnDialogService: DnDialogService,
    private blacklistService: BlacklistService,
    private _userService: UserService,
    private fb: FormBuilder,
    private pictureViewerService: PictureViewerService,
    private _notificationService: NotificationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private location: Location,
    private _httpClientHelper: HttpClientHelper,
    private _utility: Utility,
    private _apiHelper: ApiUrlHelper,
    private _toastService: ToastService,
    private _rechargeBoxService: RechargeBoxService,
  ) {
    // this.unsub = this.store.subscribe(() => this.readState());
    // this.readState();
    this.audio = new Audio();
  }

  ngAfterViewInit(): void {
    this.contacts$.pipe(filter((r: any) => r.length)).subscribe(
      r => {
        if (!this.selectedUser && this.privateUserLoaded) {
          setTimeout(() => {
            this.onSelectUser(r[0]);
            this.initiallized = true;
          }, 300);
        }
      }
    );
  }

  ngOnInit() {

    this.user = this._userService.user;



    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"] || "1");

    this.reportForm = this.fb.group({
      description: new FormControl("", [
        Validators.required,
      ])
    });
    this.socketFacade.getRecentlyRecords();
    this.loadingMessages$ = this.socketFacade.loadingMessages$;
    this.loadingContacts$ = this.socketFacade.loadingContacts$;
    this.selectedContact$ = this.socketFacade.selectedContact$;
    this.latestMessage$ = this.socketFacade.selectLatestedMessage$;
    this.unreadMessage$ = this.socketFacade.concatsHasUnreadMessage$;
    this.isUserBlocked$ = this.socketFacade.isUserBlocked$;
    this.selectCurrentMessagesGroupByDateTime$ = this.socketFacade.selectCurrentMessagesGroupByDateTime$.pipe(
      tap(() => {
        this.initiallized = true
      }));
    this.selectedContact$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(
      res => {

        if (!!res && res.id) {
          this.selectedUser = res;
          this.initiallized = true;
          this.socketFacade.getRecentlyRecordsByUser({ uid: res.id, currentUser: this.user.id, latest: true });
          this.socketFacade.getFollowStatus(res.id);
        }
      }
    );
    this.contacts$ = this.socketFacade.contacts$.pipe(
      tap((contacts) => {
        this.contacts = contacts
      })
    );
    this.settings$ = this.socketFacade.settings$;
    this.noHistory$ = combineLatest([this.loadingContacts$, this.contacts$]).pipe(
      map(([l, c]) => {
        return (!l && !(c as Array<any>).length)
      })
    )
    if (this.partner) {
      this.getPartnerInfo();
    }
    this.latestMessage$.pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((res) => {
      if (!!res) {
        if ((this.selectedUser?.id === res.uid) && (this.mode === 'BROWSE')) {
          this.unreadMessages.push(res);
        }
      }
    });

    this.subscriptions.push(
      this._userService.userState$.subscribe(user => {
        this.user = user;
      }),

      this._utility.GetOrCreateSubscript("theme.change").subscribe((theme) => {
        if (theme == "dark") {
          this.isDark = true;
        }
        else {
          this.isDark = false;
        }
      }),

      this.contacts$.pipe(filter((r: any) => r.length)).subscribe(
        r => {
          if (r.length !== 0) {
            this.contactsNums = r.length;
          }
        }
      ),

      this.unreadMessage$.subscribe(r => {
        // console.log(r);
        this.unreadSocketMsgs = r.length;
        if (this.unreadSocketMsgs === 0) {
          this.lastSocketUnread = 0;
        }
        if (this.unreadSocketMsgs > 0) {
          if (this.lastSocketUnread !== this.unreadSocketMsgs) { // 防止打开后重复提示音
            if (!this.isFirstOpen) { // 初次打开layout，不启用提示音。
              if (this._utility.isUrlContains(["/user/messages/chat"])) { // 仅在私信页面时
                this.playAudio(); // 私信页，播放socket消息提示音
              }
            }
            this.isFirstOpen = false;
            this.lastSocketUnread = this.unreadSocketMsgs;
          }
        }
      }),
    );
    this.socketFacade.getSettings();
    // 已打开私信界面，清除私信通知
    setTimeout(() => {
      this._notificationService.notifyEnterMsg(true);
    }, 200);
  }

  getPartnerInfo() {
    this.privateUserLoaded = false;
    // 根据url参数，向后端获取私信对象信息
    this.getPrivateUserByKey(this.partner.id).subscribe(r => {
      // console.log(r);
      if (r.code !== 401) {
        this.partner = {
          ...this.partner,
          name: r[0].nickname,
          avatar: r[0].headImage,
          plainUserId: r[0].touid,
          followStatus: r[0].attentionStatus === 1 ? 'Followed' : r[0].attentionStatus === 2 ? 'BiWayFollowed' : 'NotFollowed',
          gid: r[0].gid,
          isOfficalUP: r[0].isOfficalUP,
          isOfficalSpeaker: !!r[0].isOfficalSpeaker ? r[0].isOfficalSpeaker : false,
        };
        const partnerInContacts = this.contacts.filter(item => item.id === this.partner.id);
        if (partnerInContacts.length > 0) {
          this.partner = partnerInContacts[0];
        }
        this.socketFacade.SelectContact(this.partner);
        // 如果需要发送模版
        if (!!this.partner.temp) {
          this.autoSendTemplate(this.partner.temp);
          if (!this.fromSticky) {
            this.clearUrlTemp();
          }
        }
      }
      // 请求私信对象信息结束
      this.privateUserLoaded = true;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes['partner']);
    if (!changes['partner'].isFirstChange()) {
      this.getPartnerInfo();
    }
  }

  playAudio() {
    this.audio.src = this.messageSound;
    this.audio.load();
    this.audio.play();
    console.log('msg received sound played');
  }

  getPrivateUserByKey(key) {
    const userBaseInfoUrl = this._apiHelper.APIV3_ENDPOINT() + "/user/getuserbaseinfo" + '?key=' + key;
    return this._httpClientHelper.get(userBaseInfoUrl);
  }

  readState() {
    // const state = this.store.getState();
    // const userState: UsersState = state['users'];
    // this.user = userState.currentUser;
  }

  onInputChange(event) {
    this.userInput = event;
  }

  sendMessage(event) {
    if (this.userInput === undefined) {
      return;
    }
    if (this.selectedUser) {
      this.socketFacade.sendMessage({
        message: this.userInput.trim(),
        toUid: this.selectedUser.id,
        HeadImg: this.user.avatar
      });
    }
  }

  clearEditorFlag = false;
  resetFlag() {
    this.clearEditorFlag = false;
  }

  onSelectUser(event) {
    this.initiallized = false;
    this.selectedUser = event;
    this.unreadMessages = []
    this.socketFacade.SelectContact(event);
    this.clearEditorFlag = true;
    setTimeout(() => {
      this.onReachEnd(); // 由于scrollevent调整为默认回顶部，不会调用onReachEnd()，因此在切换聊天对象时，需要先手动将this.mode改为listen，默认显示最底部消息
      this.scrollToBottom();
    }, 100);
  }

  onRemoveUser(event) {
    this.initiallized = false;
    if (this.contacts.length) {
      this.selectedUser = this.contacts[0];
      this.unreadMessages = []
      this.socketFacade.SelectContact(this.selectedUser);
    } else {
      this.selectedUser = undefined;
    }
  }

  // onMessage(contactId) {
  //   setTimeout(() => {
  //     //this.youChatLog.directiveRef.update();
  //   });
  //   setTimeout(() => {
  //     this.scrollToBottom();
  //     //this.youChatLog.directiveRef.scrollToBottom(0, 0);
  //   }, 100);
  // }

  toggleEmojiBox() {
    this.showEmojiBox = !this.showEmojiBox;
    if (this.showEmojiBox) {
      this.openList = this._utility.openList(this.emojiPickerElem.nativeElement, (target) => {
        if (target.getAttribute('class')) {
          const classes = target.getAttribute('class')?.split(' ');
          if (classes.indexOf('emoji-item') > -1) {
            this.openList.unsubscribe();
            this.showEmojiBox = false;
          }
        }
      }, (target) => {
        this.openList.unsubscribe();
        this.showEmojiBox = false;
      })
    } else {
      if (this.openList) {
        this.openList.unsubscribe();
      }
    }
  }

  onSendButtonClick(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.editor.send();
  }
  lastUID = '';
  onReachStart() {

    //console.log(this.initiallized,this.loading,this.forbidInitialScrollMsg)
    if (!this.initiallized) {
      return;
    }
    if (this.loading || !this.selectedUser?.id) {
      return;
    }
    let isSameUser = this.lastUID == this.selectedUser.id;
    this.lastUID = this.selectedUser.id;
    //console.log("select user id",this.selectedUser.id)
    combineLatest([
      this.selectedContact$,
      this.socketFacade.selectEarliestMessage$])
      .pipe(
        first(),
        map(([selectedContact, earliestmessage]) => {
          if (!selectedContact['allLoaded'] && !!earliestmessage?.id) {
            this.loading = true;
            this.socketFacade.getRecentlyRecordsByUser({
              uid: selectedContact['id'],
              currentUser: this.user.id,
              messageId: earliestmessage['id'],
              latest: false
            });
          }
        }),
        takeUntil(this.unsubscribe$),
      ).pipe(delay(300)).subscribe(() => {
        if(isSameUser)  ////不同用户，不用保存滚动条位置
        this.scrollResotre();
        this.loading = false; // 延迟两次加载的间隔
      });
  }
  onReachEnd() {
    this.unreadMessages = [];
    this.mode = "LISTEN";
    if (this.initiallized && this.selectedUser && this.selectedUser.hasNew) {
      this.socketFacade.MarkMessagesAsRead({ uid: this.selectedUser.id })
    }
  }
  onScrollUp() {
   // console.log(this.mode)
    //console.log("scroll up",this.youChatLog.nativeElement.scrollHeight,(this.youChatLog.nativeElement as HTMLElement).clientHeight);

    this.mode = "BROWSE";
  }
  onChanges() {
    if (this.mode === 'LISTEN' && this.selectedUser) {
      setTimeout(() => {
        setTimeout(() => {
          this.scrollToBottom();
        }, 50);
        if (this.selectedUser.hasNew) {
          this.socketFacade.MarkMessagesAsRead({ uid: this.selectedUser.id })
        }
      });
    }

    
  }
  scrollToBottom() {
    //console.log("change scroll position")
    try {
      this.youChatLog.nativeElement.scrollTop = this.youChatLog.nativeElement.scrollHeight;
    } catch (err) { }
  }

  scrollResotre() {
    console.log("restore",this.youChatLog.nativeElement.scrollHeight,(this.youChatLog.nativeElement as HTMLElement).clientHeight);
    try {
      this.youChatLog.nativeElement.scrollTop = 10;
    } catch (err) { }
  }
 
  ngOnDestroy(): void {
    this.socketFacade.DeselectContact();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.subscriptions.forEach(s => s.unsubscribe());
    // this.unsub();
  }

  openYouChatSettings() {
    this.showYouChatSettings = true;
  }

  closeYouChatSettings() {
    this.showYouChatSettings = false;
  }

  toggleMessageFriedOnly() {
    this.socketFacade.toggleSettingsFriendOnly();
  }

  toggleChatMenu() {
    this.showChatMenu = !this.showChatMenu;
    if (this.showChatMenu) {
      this.openList = this._utility.openList(this.chatMenuElem.nativeElement, null, (target) => {
        this.openList.unsubscribe();
        this.showChatMenu = false;
      })
    } else {
      if (this.openList) {
        this.openList.unsubscribe();
      }
    }
  }

  closeChatMenu() {
    this.showChatMenu = false;
  }

  clearHistory() {
    if (!this.selectedUser) {
      return;
    }
    const confirmFormId = 'delete-messages';
    const dialogId = 'confirm-dialog-inComponent';
    this._confirmDialogService.setState(
      {
        id: confirmFormId,
        message: `<h5>确定清空所有聊天记录吗？</h5>`,
        showIcon: false,
        state: ConfirmDialogState.Unknown,
        cancelText: '确定',
        okText: '取消',
      });
    this._dnDialogService.open(dialogId);
    const deleteSubscribe = this._confirmDialogService.confirmDialogSource$.subscribe(r => {
      if (r.state !== ConfirmDialogState.Unknown) {
        this._dnDialogService.close(dialogId);
        deleteSubscribe.unsubscribe();
      }
      if (r.state === ConfirmDialogState.Cancalled && r.id === confirmFormId) {
        this.socketFacade.ClearChatHistory(this.selectedUser.id);
      }
    })
  }

  addToBlackList() {
    if (!this.selectedUser) {
      return;
    }
    const confirmFormId = 'add-to-blacklist';
    const dialogId = 'confirm-dialog-inComponent';
    this._confirmDialogService.setState(
      {
        id: confirmFormId,
        message: `<h5 style="margin-bottom: 15px;">您确定要将TA加入黑名单吗？</h5><h5>(加入黑名单将会屏蔽TA的私聊和评论)</h5>`,
        showIcon: false,
        state: ConfirmDialogState.Unknown,
        cancelText: '确定',
        okText: '取消',
      });
    this._dnDialogService.open(dialogId);
    const subscribe = this._confirmDialogService.confirmDialogSource$.subscribe(r => {
      if (r.state !== ConfirmDialogState.Unknown) {
        this._dnDialogService.close(dialogId);
        subscribe.unsubscribe();
      }
      if (r.state === ConfirmDialogState.Cancalled && r.id === confirmFormId) {
        this.blacklistService.addBlacklist({ id: this.selectedUser.plainUserId }).subscribe(
          (r: any) => {
            // console.log(r);
            if (r.code === 401) {
              return;
            };
            // this._messageDialogService.setState({ message: '用户拉黑成功' });
            this._dnDialogService.open('message-dialog-inComponent',{ message: '用户拉黑成功' });
            this.socketFacade.addUserToBlock();
            // setTimeout(() => {
            //   this.socketFacade.getRecentlyRecords();
            // }, 200);
          }
        )
      }
    })
  }

  reportUser() {
    this.reportForm = this.fb.group({
      description: new FormControl("", [
        Validators.required,
      ])
    });
    this._dnDialogService.open('report-chat', {
      size: { width: 397, height: 419 },
      toUid: this.selectedUser?.id
    });
  }

  report() {
    const reason = this.reportForm.value.description;
    this.socketFacade.report({ touid: this.selectedUser.id, reason, infotype: this.reportReason })
  }

  close() {

  }

  changeFollowStatus() {
    this.socketFacade.changeFollowStatus(this.selectedUser.id);
  }

  addImage() {
    (this.imageInput.nativeElement as HTMLElement).click();
  }

  onImageChange(event) {
    const files = event.target.files || event.dataTransfer.files;

    if (files.length === 0)
      return;

    var extensions = getFileExtensions(files[0].name);

    if (this.allowImageExtensions.findIndex(p => p == extensions) == -1) {
      return false;
    }

    if (!event.target.files) {
      event.target.files = event.dataTransfer.files;
    }

    if (files[0].size > this.maxiumImageFileSize) {
      // this._messageDialogService.setState({ message: '超过最大尺寸' });
      this._dnDialogService.open('message-dialog-inComponent',{ message: '超过最大尺寸' });
      return false;
    }
    const imgSize = files[0].size
    if (imgSize > 1 * 1024 * 1024) {
      this._toastService.showBlackToast('图片发送中，请稍等...');
    }

    var reader = new FileReader();

    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      var image = new Image();
      image.src = _event.target.result.toString();

      image.onload = (r: any) => {
        // console.log(imgSize);
        // 真实上传限制为2MB，大于2MB，压缩后再上传
        if (imgSize > 2 * 1024 * 1024) {
          const rawImgBase64 = image.src;
          this.compress(rawImgBase64, 1.5); // 对base64进行压缩
          return;
        }

        const imgBase64 = image.src.split(',')[1]; // 去掉逗号前的部分
        // this.socketService.sendMessage({ code: imgBase64 }).subscribe();
        this.socketFacade.sendMessage({
          code: imgBase64,
          toUid: this.selectedUser.id,
          HeadImg: this.user.avatar
        })
      }

    }
    this.imageInput.nativeElement.value = ''; // 清除Input value
  }

  // base64图片压缩+上传
  compress(base64, rate) {
    let _img = new Image();
    _img.src = base64;
    _img.onload = () => {
      let _canvas = document.createElement('canvas');
      let w = _img.width / rate;
      let h = _img.height / rate;
      _canvas.setAttribute('width', w + 'px');
      _canvas.setAttribute('height', h + 'px');
      _canvas.getContext('2d').drawImage(_img, 0, 0, w, h);
      let compressed_base64 = _canvas.toDataURL("image/jpeg");
      _canvas.toBlob(blob => {
        // console.log('size', blob.size);
        if (blob.size > 2 * 1024 * 1024) {  // 如果还大于2MB，继续压缩
          this.compress(compressed_base64, rate);
        } else {
          // console.log(compressed_base64);
          // 上传
          const imgBase64 = compressed_base64.split(',')[1]; // 去掉逗号前的部分
          this.socketFacade.sendMessage({
            code: imgBase64,
            toUid: this.selectedUser.id,
            HeadImg: this.user.avatar
          })
        }
      }, "image/jpeg");
    }
  }

  openPictureViewer(current) {
    this.socketFacade.selectCurrentImages$
      .pipe(
        take(1)
      )
      .subscribe(
        (items) => {
          let index = 0;
          const images = [...items].reverse().map((i, idx) => {
            if (i.id === current.id) {
              index = idx;
            }
            return i.context;
          })
          this.pictureViewerService.open(images, index)
        }
      )
  }

  closeChatLog() {
    this.onCloseChatLog.emit({
      showChatLog: false,
    });
  }

  autoSendTemplate(tempType) {
    if (this.selectedUser) {
      // 取cookie的自动发送模板冷却
      // const cdCookie = this.stringToJSON(this.getCookie('cd'));
      // if (cdCookie === undefined) {
      //   this.setCookie(
      //     'cd',
      //     JSON.stringify(this.cookies),
      //     1
      //   );
      // } else {
      //   this.cookies = cdCookie;
      // }
      // 取API自动发送模板冷却list
      const list = this.user.autoSendServiceMsgUids;

      let templateMsg;
      // let cookieObj;
      switch (tempType) {
        case 'recharge':
          // if (this.cookies.rechargeCD) {
          //   templateMsg === undefined;
          //   return;
          // };
          if (this.partner.product) {
            templateMsg = `我正在购买${this.partner.product}<br>我的账号是：${this.user.accountName}<br>我的昵称是：${this.user.nickname}<br>希望人工充值`;
          } else {
            templateMsg = `我的账号是：${this.user.accountName}<br>我的昵称是：${this.user.nickname}<br>希望人工充值`;
          }
          // cookieObj = Object.assign(
          //   this.cookies,
          //   { rechargeCD: true }
          // );
          break;
        case 'cs':
          // if (this.cookies.csCD) {
          //   templateMsg === undefined;
          //   return;
          // };
          templateMsg = `本账号绑定的邮箱和手机号分别是：<br>邮箱：${this.user.name}<br>手机号：<br>所在地区：${this.user.region}<br>会员截至时间：${this.user.daysOfMembership > 0 ? this.user.membershipExpiryDate : ''}`;
          // cookieObj = Object.assign(
          //   this.cookies,
          //   { csCD: true }
          // );
          break;
        case 'activitycs':
            templateMsg = `我正在参加【幸运大抽奖】活动<br>-------------------<br>本账号绑定的邮箱和手机号分别是：<br>邮箱：${this.user.name}<br>手机号：`;
            break;
        case 'tgc':
          // if (this.cookies.tgcCD) {
          //   templateMsg === undefined;
          //   return;
          // };
          templateMsg = `本账号绑定的邮箱和手机号分别是：<br>邮箱：${this.user.name}<br>手机号：<br>会员截至时间：${this.user.daysOfMembership > 0 ? this.user.membershipExpiryDate : ''}`;
          // cookieObj = Object.assign(
          //   this.cookies,
          //   { tgcCD: true }
          // );
          break;
      }
      setTimeout(() => {
        // this.setCookie(
        //   'cd',
        //   JSON.stringify(cookieObj),
        //   1
        // );
        const allowAutoSend = list.indexOf(this.selectedUser.plainUserId) === -1 ? true : false;
        // console.log(allowAutoSend);
        if (!!templateMsg && allowAutoSend) {
          console.log(templateMsg);
          this.socketFacade.sendMessage({
            message: templateMsg,
            toUid: this.selectedUser.plainUserId,
            HeadImg: this.user.avatar
          });
          list.push(this.selectedUser.plainUserId);
        }
      }, 50);
    }
  }

  clearUrlTemp() {
    const urlChanged = this._router.createUrlTree(
      [],
      {
        relativeTo: this._activatedRoute,
        queryParams: {
          // avatar: this.partner.avatar,
          // name: this.partner.name,
          id: this.partner.id,
        },
      }
    ).toString();
    this.location.go(urlChanged);
  }

  // cookies = {
  //   rechargeCD: false,
  //   csCD: false,
  //   tgcCD: false,
  // };

  // setCookie(name, value, days) {
  //   var expires = "";
  //   if (days) {
  //       var date = new Date();
  //       date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  //       expires = "; expires=" + date.toUTCString();
  //   }
  //   var host = this._utility.GetHost("", true);
  //   var domain = "domain=" + (host && host.indexOf(".") == 0 ? host : "." + host);
  //   document.cookie = name + "=" + (value || "") + expires + "; path=/;" + domain;
  // }

  // getCookie(name) {
  //     const value = `; ${document.cookie}`;
  //     const parts = value.split(`; ${name}=`);
  //     if (parts.length === 2) return parts.pop().split(';').shift();
  // }

  // stringToJSON(string) {
  //     if (!!string) {
  //         return JSON.parse(string);
  //     } else {
  //         return;
  //     }
  // }

  navToPage() {
    // console.log(this.selectedUser);
    this._rechargeBoxService.changeDisplayStatus(false);
    this._router.navigate(['/user/messages/chat'], { queryParams: { id: this.selectedUser.id } });
    this.closeChatLog();
  }

  navToUserPage() {
    if (this.fromSticky && this.selectedUser) {
      // console.log(this.selectedUser);
      this._router.navigate(['/space/' + this.selectedUser.id]);
      this.closeChatLog();
    } else {
      return;
    }
  }

  focusInEditor() {
    // make sure focus is on the element
    this.editor.editorRef.nativeElement.focus();
    // select all the content in the element
    document.execCommand('selectAll', false, null);
    // collapse selection to the end
    document.getSelection().collapseToEnd();
  }
}
